import React from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";

function HeartIcon() {
  return (
    <span className="footer-heart" aria-hidden="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="18"
        height="18"
        className="inline-block align-middle"
      >
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    </span>
  );
}

export default function Footer() {
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div py-8 bg-base-200">
        <p className="footer-text text-center text-base-content/70">
          Made with <HeartIcon /> by Abhinav
        </p>
      </div>
    </Fade>
  );
}
